// localStorage persistence for last analysis and email lead capture.

const ANALYSIS_KEY = "sentinel.lastAnalysis";
const EMAIL_KEY = "sentinel.leadEmail";

export function saveAnalysis(payload) {
  try {
    const data = {
      savedAt: new Date().toISOString(),
      result: payload,
    };
    window.localStorage.setItem(ANALYSIS_KEY, JSON.stringify(data));
  } catch (e) {
    // ignore quota / disabled
  }
}

export function loadAnalysis() {
  try {
    const raw = window.localStorage.getItem(ANALYSIS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.result) return null;
    return parsed;
  } catch (e) {
    return null;
  }
}

export function clearAnalysis() {
  try {
    window.localStorage.removeItem(ANALYSIS_KEY);
  } catch (e) {
    // ignore
  }
}

export function saveLeadEmail(email, options = {}) {
  try {
    const existing = loadLeadEmail() || {};
    const payload = {
      ...existing,
      email,
      wantsApp: options.wantsApp !== undefined ? !!options.wantsApp : existing.wantsApp,
      savedAt: new Date().toISOString(),
      unsubscribeToken: options.unsubscribeToken ?? existing.unsubscribeToken ?? null,
      leadId: options.leadId ?? existing.leadId ?? null,
      source: options.source ?? existing.source ?? null,
      analysisLinked:
        options.analysisLinked !== undefined
          ? !!options.analysisLinked
          : !!existing.analysisLinked,
      emailsSent: options.emailsSent ?? existing.emailsSent ?? null,
    };
    window.localStorage.setItem(EMAIL_KEY, JSON.stringify(payload));
  } catch (e) {
  }
}

export function loadLeadEmail() {
  try {
    const raw = window.localStorage.getItem(EMAIL_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
